import React from 'react';

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import appTheme from '../components/Theme';

const FAQ = () => {

  const windowGlobal = typeof window !== 'undefined' && window;
  let theme = "light";

  try {
    theme = windowGlobal.localStorage.getItem("neumTheme")
  } catch {
    
  }

  return (
    <Layout>
      <SEO title="FAQ" />
      <div style={appTheme[theme]} className="faq-container">
        <b style={appTheme[theme]}>Is there any new functionality here?</b><br></br><br></br>
        No - you can achieve the same results by passing in weird strings in the Github search bar.
        I created this because I was frustrated I couldn't do a search for repos by popularity and date together.<br></br><br></br>
        <b style={appTheme[theme]}>Can I search for anything besides repos?</b><br></br><br></br>
        For now I have just done this for repos as that is the most common use case.<br></br><br></br>      
        <b style={appTheme[theme]}>I don't see any results! WTF?!?</b><br></br><br></br>
        Your overzealous searching hit my poor API limit (its per minute). Take a few breaths and try again in a minute. Thanks!<br></br>
      </div>
    </Layout>
  )
};

export default FAQ;
